import { Component } from "@angular/core";

@Component({
  selector: "search-icon-svg",
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol id="searchIcon" viewBox="0 0 16 16" fill="none">
        <path
          d="M14.75 14.75L11.4875 11.4875M7.25 3.5C9.32107 3.5 11 5.17893 11 7.25M13.25 7.25C13.25 10.5637 10.5637 13.25 7.25 13.25C3.93629 13.25 1.25 10.5637 1.25 7.25C1.25 3.93629 3.93629 1.25 7.25 1.25C10.5637 1.25 13.25 3.93629 13.25 7.25Z"
          stroke="var(--stroke-color, #2D405D)"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
    </svg>
  `,
})
export class SearchIconSvgComponent {}
